module.exports = __webpack_public_path__ + "media/bootstrap-icons/moon-stars-fill-567a7204.svg";